import { Dispatch, memo, ReactNode, SetStateAction } from 'react';
import { Button } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import cn from 'classnames';

import { QueryParams } from '../FiltersControls/FiltersControls';
import { useDispatch } from 'redux/store';
import { Typography } from '../Typography/Typography';

import s from './styles.module.scss';

interface FiltersProps {
  children: ReactNode;
  filtersListParams?: QueryParams;
  filtersErrors?: Record<string, string>;
  setParams: ActionCreatorWithPayload<QueryParams>;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  onReset: () => void;
}

const Filters = (props: FiltersProps) => {
  const { children, filtersListParams, filtersErrors, setParams, opened, setOpened, onReset } = props;

  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(setParams({ ...filtersListParams, page: 1 }));

    setOpened(false);
  };

  const handleReset = () => {
    onReset();
    
    setOpened(false);
  }

  const hasError = filtersErrors ? Object.values(filtersErrors).some((error) => !!error) : false;

  return (
    <>
      <button
        className={cn(s.closeFilters, { [s.opened]: opened })}
        onClick={() => setOpened(false)}
      />
      <aside className={cn(s.filters, { [s.opened]: opened })}>
        <header>
          <Typography fontSize="1.25rem" fontWeight={500} lineHeight="32px">
            Фильтры
          </Typography>
        </header>
        <main className={s.main}>{children}</main>
        <footer className={s.footer}>
          <Button variant="text" onClick={handleReset} sx={{ textTransform: 'none' }}>
            Сбросить
          </Button>
          <Button
            disabled={hasError}
            variant="contained"
            onClick={handleSubmit}
            sx={{ textTransform: 'none' }}
          >
            Применить
          </Button>
        </footer>
      </aside>
    </>
  );
};

export const FiltersMemo = memo(Filters);
